var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { Input, Select, useId, useValue, useFocus, createClassName, statusIcons, flatObj } from '../common';
import Translate from '../Translate';
import cn from 'classnames';

var PhoneNumberInput = function PhoneNumberInput(props) {
  var val = props.value || '';

  var callingCodeValue = ((props.callingCodes || []).slice().sort(function (a, b) {
    return b.value - a.value;
  }).find(function (c) {
    return val.startsWith(c.value);
  }) || (props.callingCodes || [])[0] || {}).value || '';
  var phoneNumberValue = callingCodeValue ? val.replace(new RegExp('^' + callingCodeValue), '').replace(/^0*/, '') : val;

  var callingCodeSelect = {
    id: useId(),
    value: useValue(callingCodeValue),
    focus: useFocus()
  };
  var phoneNumberInput = {
    id: useId(),
    value: useValue(phoneNumberValue),
    focus: useFocus()
  };

  var createValue = function createValue() {
    var _Object$values;

    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return Object.values((_Object$values = {}, _defineProperty(_Object$values, callingCodeSelect.id, callingCodeSelect.value.value), _defineProperty(_Object$values, phoneNumberInput.id, phoneNumberInput.value.value), _defineProperty(_Object$values, id, value), _Object$values)).join('');
  };

  var _onChange = function _onChange(e) {
    return props.onChange && props.onChange(e, createValue(e.target.id, e.target.value));
  };

  var _onBlur = function _onBlur(e) {
    return props.onBlur && props.onBlur(e, createValue(e.target.id, e.target.value));
  };

  var inputs = [callingCodeSelect, phoneNumberInput];
  var className = createClassName('tg-phonenumber-input', {
    hasValue: inputs.some(function (i) {
      return i.value.hasValue;
    }),
    hasFocus: inputs.some(function (i) {
      return i.focus.hasFocus;
    }),
    status: props.status
  });

  return React.createElement(
    'div',
    { className: cn(props.className, className) },
    callingCodeSelect.value.hasValue && React.createElement(
      Select,
      _extends({}, flatObj(callingCodeSelect), {
        name: props.name + '_calling-code',
        label: React.createElement(Translate, { id: 'label.calling-code', defaultMessage: 'Calling code' }),
        onChange: function onChange(e) {
          callingCodeSelect.value.onChange(e.target.value);
          _onChange(e);
        },
        onBlur: function onBlur(e) {
          callingCodeSelect.focus.onBlur();
          _onBlur(e);
        },
        status: props.status,
        leadingLane: [props.selectIcon].filter(function (i) {
          return i;
        }) }),
      (props.callingCodes || []).map(function (c, i) {
        return React.createElement(
          Select.Option,
          { key: c.value + i, value: c.value },
          c.label
        );
      })
    ),
    React.createElement(Input, _extends({}, flatObj(phoneNumberInput), {
      autoFocus: props.autoFocus,
      type: 'tel',
      name: props.name + '_number',
      label: React.createElement(Translate, {
        id: 'label.mobile_number',
        defaultMessage: 'MobilePhoneNumber'
      }),
      onChange: function onChange(e) {
        phoneNumberInput.value.onChange(e.target.value);
        _onChange(e);
      },
      onBlur: function onBlur(e) {
        phoneNumberInput.focus.onBlur();
        _onBlur(e);
      },
      status: props.status,
      leadingLane: [props.inputIcon].filter(function (i) {
        return i;
      }),
      trailingLane: [statusIcons[props.status]].filter(function (i) {
        return i;
      })
    })),
    React.createElement(Input, { type: 'hidden', name: props.name, value: createValue() }),
    React.createElement(
      'div',
      { className: 'tg-phonenumber-input__status-text' },
      props.statusText
    )
  );
};

export default PhoneNumberInput;